<template>
  <div class="waiter clear">
    <div class="left">
          <span class="TitleImg">
            <!--<img v-if="headImgFn&&headImgFn.indexOf('/null') < 0" :src="headImgFn.replace('http:','')">-->
            <img v-if="headImg && headImg!==''" :src='imgShowAddressFront + headImg + imgShowAddressEndFirst + "/w/50/h/50" + imgShowAddressEndSecond' alt="">
            <img v-else src="../../../../assets/img/yonghu/logo.png">
          </span>
    </div>
    <div class="right">
      <div class="row row1">
        <span>{{name}}</span>
        <span>{{sex}}</span>
      </div>
      <div class="row row3" v-if="carName">
        <span class="carName">
          {{carName}}
        </span>
        <span class="carColor">
          {{carColor}}
        </span>
      </div>
      <div class="row row2" v-if="location">
        {{location}}
      </div>
      <div class="row row3" v-if="carNo">
          <span class="carNo">
            {{carNo}}
          </span>
        <span class="waiterCarType" v-if="carType">
            {{carType}}
        </span>
      </div>
      <div class="row row3" v-if="paotuiType">
          <span class="paotuiType">
            {{paotuiType}}
          </span>
      </div>
    </div>
    <span class="waiterPhone" v-if="phone">
      <a :href="'tel:'+phone">
        <i class="iconfont icon-dianhua1"></i>
      </a>
    </span>
  </div>
</template>

<script>
  export default {
    name: 'xk-waiter',
    props: ['src', 'name', 'carNo', 'carName', 'carColor', 'carType', 'sex', 'location', 'phone', 'paotuiType', 'headImg'],
    computed: {
      headImgFn: function () {
        if (this.$props.headImg) {
          return this.$props.headImg
        }
      }
    },
    data () {
      return {
        imgShowAddressFront: 'https://assets.xiaokayun.cn/',
        imgShowAddressEndFirst: '?imageView2/1',
        imgShowAddressEndSecond: navigator.userAgent.indexOf('Chrome') > -1 ? '/format/webp/q/75%7Cimageslim' : '/format/png/q/75%7Cimageslim'
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/less" lang="less">
  .waiter {
    box-sizing: border-box;
    width: 100%;
    padding: 2rem 2.08333rem;
    background-color: #fff;
    position: relative;
    /*display: flex;*/
    /*align-items: center;*/
    /*justify-content: flex-start;*/
    .left {
      float: left;
      padding-top: 0.3rem;
      .TitleImg {
        height: 5rem;
        width: 5rem;
        border-radius: 50% !important;
        position: relative;
        overflow: hidden;
        margin-right: 1rem;
      }
      img {
        display: inline-block;
        vertical-align: middle;
        width: 100%;
        position: absolute;
        left: 50%;
        top: 50%;
        border-radius: 50%;
        transform: translate(-50%, -50%);
      }
    }
    .right {
      float: left;
      max-width: 60%;
      overflow: hidden;
      .row {
        font-size: 1rem;
      }
      .row1 {
        color: #333333;
        font-size: 1.2rem;
      }
      .row2 {
        font-size: 1rem;
        width: 50vw;
        color: #666666;
        .carName {
          width: 100%;
          margin-top: 0.3rem;
        }
      }
      .row3 {
        color: #999999;
        margin-top: 0.4rem;
        .carNo {
          border-radius: 1rem;
          color: rgba(255, 105, 87, 0.8);
        }
        .waiterCarType {
          padding: 0 0.4rem;
          color: #999;
          border-radius: 1rem;
        }
        .paotuiType {
          margin-top: 0.3rem;
          padding: 0 0.5rem;
          background-color: #f06553;
          color: #fff;
          line-height: 1.8rem;
          border-radius: 0.9rem;
        }
      }
      .carName {
        display: inline-block;
        margin-right: 5px;
      }
    }
    .waiterPhone {
      position: absolute;
      right: 1.5rem;
      top: 50%;
      width: 3rem;
      height: 3rem;
      transform: translate(0, -50%);
      a {
        width: 100%;
        height: 100%;
      }
      i {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        font-size: 2.5rem;
        color: #f06553;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// waiter.vue?b45a2d00